 
import { put, takeLatest } from 'redux-saga/effects';
import Services from 'services';
import hooks from 'hooks';
import types from 'redux/types';
import {
  ADD_CARD_URL,
  GET_LIST_CARD_URL,
  MAKE_DEFAULT_CARD_URL,
  DELETE_CARD_URL,
  GET_HISTORY_CHARGE_URL,
  SET_AUTO_RECHARGE_URL,
  PURCHASE_CREDIT_URL,
  LOAD_CREDIT_PACKAGE,
} from '../../consts/api';
import { getUserServlet } from './userServletSaga';
import { getBalance } from './balanceSaga';
import { TIME_OUT_CLOSE_TOAST } from 'consts/data';
import { showError } from 'helpers/handleError';

const { Notification } = hooks;

const checkLastHistory = (listHistory) => listHistory && listHistory.length < 9;

function* getHisCharge() {
  try {
    const requestHistoryOfCharge = yield Services.get(GET_HISTORY_CHARGE_URL);
    const isLastHistory = checkLastHistory(requestHistoryOfCharge.data);
    yield put({
      type: types.REQUEST_GET_LIST_HISTORY_CHARGE_SUCCESS,
      data: requestHistoryOfCharge.data,
      isLastHistory,
    });
  } catch (error) {
    yield put({ type: types.REQUEST_GET_LIST_HISTORY_CHARGE_FAILED, error });
    showError(error);
  }
}

function* deleteCard(data) {
  const { cardId, setSubmitting, toggle } = data;
  setSubmitting(true);
  try {
    yield Services.delete(`${DELETE_CARD_URL}?cardId=${cardId}`);
    yield put({ type: types.REQUEST_DELETE_CARD_SUCCESS });
    yield getListCard();
    Notification('success', 'Delete Card successfully', 'Success', TIME_OUT_CLOSE_TOAST);
    setSubmitting(false);
    toggle();
  } catch (error) {
    yield put({ type: types.REQUEST_DELETE_CARD_FAILED, error });
    showError(error);
    setSubmitting(false);
  }
}

function* setDefaultCard(data) {
  const { cardId } = data;
  try {
    const requestMakeDefault = yield Services.post(`${MAKE_DEFAULT_CARD_URL}?cardId=${cardId}`);
    if (!requestMakeDefault.data) {
      yield put({ type: types.REQUEST_LIST_CARD_FAILED, error: requestMakeDefault.data, cardId });
      showError('[MAKE_DEFAULT_CARD] ' + 'FAIL, Try again or report me this issue!');
    }
    yield getListCard();
    yield put({ type: types.REQUEST_MAKE_DEFAULT_SUCCESS, cardId });
    Notification('success', 'Set as default successfully', 'Success', TIME_OUT_CLOSE_TOAST);
  } catch (error) {
    yield put({ type: types.REQUEST_LIST_CARD_FAILED, error, cardId });
    showError(error);
  }
}

function* getListCard() {
  try {
    const requestListCard = yield Services.get(GET_LIST_CARD_URL);
    yield put({ type: types.REQUEST_LIST_CARD_SUCCESS, data: requestListCard.data });
  } catch (error) {
    yield put({ type: types.REQUEST_LIST_CARD_FAILED, error });
    showError(error);
  }
}

function* createCard(data) {
  const { info, setSubmitting, toggle, stripe, card } = data;
  const { name, phone, email, postal_code: zip } = info;
  try {
    setSubmitting(true);
    // Get Token
    const requestToken = yield stripe.createToken(card);
    if (requestToken.error) {
      yield put({ type: types.REQUEST_ADD_CARD_METHOD_FAILED, error: requestToken.error });
      setSubmitting(false);
      return;
    }
    // Request To Create
    const { id: token } = requestToken.token || {};
    const requestAddCard = yield Services.post(ADD_CARD_URL, { name, phone, email, zip, token });
    if (!requestAddCard.data) {
      yield put({ type: types.REQUEST_ADD_CARD_METHOD_FAILED, error: {} });
      showError('Something went wrong. Please contact our supporters!');
      setSubmitting(false);
      return;
    }
    yield put({ type: types.REQUEST_ADD_CARD_METHOD_SUCCESS });
    yield getListCard();
    Notification('success', 'Payment method is created successfully!', '', TIME_OUT_CLOSE_TOAST);
    setSubmitting(false);
    toggle();
  } catch (error) {
    yield put({ type: types.REQUEST_ADD_CARD_METHOD_FAILED, error: {} });
    showError(error);
    setSubmitting(false);
  }
}

function* setAutoRecharge(data) {
  const { recharge, numberRecharge, callbacks } = data;
  try {
    const requestAutoRecharge = yield Services.post(
      `${SET_AUTO_RECHARGE_URL}?recharge=${recharge ? 'on' : 'off'}&volume=${numberRecharge}`
    );
    if (requestAutoRecharge.data) {
      yield getUserServlet();
      Notification('success', 'Change AutoRecharge Successfully!', 'Success', TIME_OUT_CLOSE_TOAST);
      callbacks && callbacks.onSuccess(requestAutoRecharge);
      return;
    }

    showError('[SET_AUTO_RECHARGE] ' + 'FAIL, Try again or report to us!');
    callbacks && callbacks.onFailed('[SET_AUTO_RECHARGE] ' + 'FAIL, Try again or report to us!');
  } catch (error) {
    showError(error);
    callbacks && callbacks.onFailed(error);
  }
}

function* purchaseCredit(data) {
  const { packageId, callbacks } = data;
  const { onSuccess, onFailed } = callbacks || {};

  try {
    const requestPurchaseCredit = yield Services.post(
      `${PURCHASE_CREDIT_URL}?packageId=${packageId}`
    );
    if (requestPurchaseCredit.data) {
      yield getBalance();
      yield getHisCharge();
      Notification('success', 'Purchase Successfully!', '', TIME_OUT_CLOSE_TOAST);
      onSuccess && onSuccess();
      return;
    }

    showError(`FAIL! Please contact to our supporters!`);
    onFailed && onFailed();
  } catch (error) {
    showError(error);
    onFailed && onFailed(error);
  }
}

function* getListPackage() {
  try {
    const requestListPackage = yield Services.get(LOAD_CREDIT_PACKAGE);
    if (typeof requestListPackage.data === 'object') {
      yield put({
        type: types.REQUEST_LIST_PACKAGE_SUCCESS,
        data: Object.values(requestListPackage.data),
      });
      return;
    }
    yield put({ type: types.REQUEST_LIST_PACKAGE_FAILED, error: 'fail' });
    showError('[GET_LIST_PACKAGE] ' + 'fail');
  } catch (error) {
    yield put({ type: types.REQUEST_LIST_PACKAGE_FAILED, error });
    showError(error);
  }
}

function* getMoreHistoryCharge(data) {
  const { lastId } = data;
  try {
    const requestHistoryOfCharge = yield Services.get(
      `${GET_HISTORY_CHARGE_URL}?afterId=${lastId}`
    );
    // 10 records each request api
    const isLastHistory = checkLastHistory(requestHistoryOfCharge.data);
    yield put({
      type: types.REQUEST_GET_MORE_HISTORY_CHARGE_SUCCESS,
      data: requestHistoryOfCharge.data,
      isLastHistory,
    });
  } catch (error) {
    yield put({ type: types.REQUEST_GET_MORE_HISTORY_CHARGE_FAILED, error });
    showError(error);
  }
}

export default function* () {
  yield takeLatest(types.REQUEST_ADD_CARD_METHOD, createCard);
  yield takeLatest(types.REQUEST_LIST_CARD, getListCard);
  yield takeLatest(types.REQUEST_MAKE_DEFAULT, setDefaultCard);
  yield takeLatest(types.REQUEST_DELETE_CARD, deleteCard);
  yield takeLatest(types.REQUEST_GET_LIST_HISTORY_CHARGE, getHisCharge);
  yield takeLatest(types.REQUEST_SET_AUTO_RECHARGE, setAutoRecharge);
  yield takeLatest(types.REQUEST_PURCHASE, purchaseCredit);
  yield takeLatest(types.REQUEST_LIST_PACKAGE, getListPackage);
  yield takeLatest(types.REQUEST_GET_MORE_HISTORY_CHARGE, getMoreHistoryCharge);
}
